import { useCallback, useMemo, useState } from 'react';
import { NavMarker } from 'react-rhumb';
import { TRIGGER_RHUMB_SUCCESS, TRIGGER_RHUMB_PARTIAL_SUCCESS, TRIGGER_RHUMB_FAILURE } from 'crm-events-data';
import mark from 'crm-fe-perf/timing/mark';
import { TimelineLoaded } from 'crm-fe-perf/timing/marks/crm-records-ui/performanceMarks';
import { useCardRenderMarkers } from 'crm-cards-sdk/hooks/useCardRenderMarkers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RhumbState = {
  error: 'error',
  loading: 'loading',
  partialSuccess: 'partialSuccess',
  success: 'success'
};
export function useTimelineRhumbActionHandler() {
  const [rhumbState, setRhumbState] = useState(RhumbState.loading);
  const {
    SuccessMarker,
    ErrorMarker
  } = useCardRenderMarkers();
  const handleTimelineRhumbAction = useCallback(actionType => {
    switch (actionType) {
      case TRIGGER_RHUMB_SUCCESS:
        mark(TimelineLoaded);
        setRhumbState(RhumbState.success);
        break;
      case TRIGGER_RHUMB_PARTIAL_SUCCESS:
        setRhumbState(RhumbState.partialSuccess);
        break;
      case TRIGGER_RHUMB_FAILURE:
        setRhumbState(RhumbState.error);
        break;
      default:
      // do nothing
    }
  }, []);
  const rhumbMarker = useMemo(() => {
    switch (rhumbState) {
      case RhumbState.success:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(SuccessMarker, {}), /*#__PURE__*/_jsx(NavMarker, {
            name: "TIMELINE"
          })]
        });
      case RhumbState.partialSuccess:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(SuccessMarker, {}), /*#__PURE__*/_jsx(NavMarker, {
            name: "TIMELINE_PARTIAL_SUCCESS"
          })]
        });
      case RhumbState.error:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ErrorMarker, {}), /*#__PURE__*/_jsx(NavMarker, {
            name: "TIMELINE_ERROR"
          })]
        });
      case RhumbState.loading:
      default:
        return null;
    }
  }, [ErrorMarker, SuccessMarker, rhumbState]);
  return {
    handleTimelineRhumbAction,
    rhumbMarker
  };
}